import moment from 'moment-timezone';
import enums from '@/utils/enums';
import types from '@/utils/notificationTypes';
import { formatMoney } from '@/utils/stringUtils';
import { NOTIFICATIONS, EVENT_TYPES_BY_ID } from '@/utils/constants';

const getRecentOnes = (dateKey, item) => {
  return item.filter((o) =>
    moment(o[dateKey]).isAfter(moment().subtract(6, 'months'))
  );
};

export default {
  [NOTIFICATIONS.MUTATE_VISUALIZED]: (state, payload) => {
    state.visualized = payload;
  },

  [NOTIFICATIONS.MUTATE_ID]: (state, payload) => {
    state.id = payload;
  },

  [NOTIFICATIONS.LOADING]: (state, payload) => {
    state.loading = payload;
  },

  [NOTIFICATIONS.MUTATE_BULLETINS]: (state, payload) => {
    const bulletins = getRecentOnes('lastModified', payload);
    const bulletinNotifications = bulletins.map((o) => ({
      title: `Novo comunicado: ${o.title}`,
      id: o._id,
      time: o.lastModified,
      link: o.attachment,
      type: types.BULLETIN,
      info: { title: o.title },
      visualized: false,
    }));
    state.bulletinNotifications = bulletinNotifications;
  },

  [NOTIFICATIONS.MUTATE_GENERAL_DOCUMENTS]: (state, payload) => {
    const generalDocs = getRecentOnes('lastModified', payload);
    const generalDocsNotifications = generalDocs.map((o) => ({
      title: `Novo documento: ${o.title}`,
      id: o._id,
      time: o.lastModified,
      link: o.attachment,
      type: types.GENERAL_DOCS,
      info: { title: o.title },
      visualized: false,
    }));
    state.generalDocumentNotifications = generalDocsNotifications;
  },

  [NOTIFICATIONS.MUTATE_LEGAL_DOCUMENTS]: (state, payload) => {
    const { legalDocuments: texts, legalDocumentsStatusValues: status } = enums;
    const legalDocs = getRecentOnes('lastModified', payload);
    const onlyStarted = legalDocs.filter(
      (o) => o.legalDocument.status === status.done
    );
    const legalDocsNotifications = onlyStarted.map((o) => ({
      title: `Atualização do documento legal ${
        texts[o.legalDocument.type].shortName
      }`,
      id: o._id,
      time: o.lastModified,
      link: o.attachment || { name: 'documents', params: { type: 'legal' } },
      type: types.LEGAL_DOCS,
      info: { shortName: texts[o.legalDocument.type].shortName },
      visualized: false,
    }));
    state.legalDocumentNotifications = legalDocsNotifications;
  },

  [NOTIFICATIONS.MUTATE_TO_EXPIRE_PAYMENT_SLIPS]: (state, payload) => {
    const paymentSlips = getRecentOnes('expirationDate', payload);
    const paymentSlipsNotifications = paymentSlips.map((o) => ({
      title: `Boleto próximo vencimento: ${formatMoney(o.discountedValue)}`,
      id: o.id.toString(),
      time: moment(o.expirationDate).subtract(20, 'days').format(),
      type: types.TO_EXPIRE_SLIPS,
      visualized: false,
      info: {
        serieCode: o.serieCode,
        expirationDate: o.expirationDate,
        parcelCode: o.parcelCode,
        discountedValue: o.discountedValue,
      },
      link: o.ready && o.slipUrl ? o.slipUrl : '/boleto-indisponivel',
    }));
    state.paymentSlipNotifications = paymentSlipsNotifications;
  },

  [NOTIFICATIONS.MUTATE_LATE_PAYMENT_SLIPS]: (state, payload) => {
    const paymentSlipLate = getRecentOnes('lastModified', payload);
    const paymentSlipLateNotifications = paymentSlipLate.map((o) => ({
      title: `Boleto em atraso: ${formatMoney(o.paymentTotal)}`,
      id: o._id,
      time: o.lastModified,
      link: o.slipUrl,
      type: types.LATE_SLIPS,
      info: {
        contractId: o.contractId,
        paymentTotal: o.paymentTotal,
        expirationDate: o.expirationDate,
        solicitationCode: o.solicitationCode,
      },
      visualized: false,
    }));
    state.paymentSlipLateNotifications = paymentSlipLateNotifications;
  },

  [NOTIFICATIONS.MUTATE_ANTICIPATION_PAYMENT_SLIPS]: (state, payload) => {
    const paymentSlipAnticipation = getRecentOnes('lastModified', payload);
    const paymentSlipAnticipationNotifications = paymentSlipAnticipation.map(
      (o) => ({
        title: `Boleto para antecipação: ${formatMoney(o.paymentTotal)}`,
        id: o._id,
        time: o.lastModified,
        link: o.slipUrl,
        type: types.ANTICIPATION_SLIPS,
        info: {
          contractId: o.contractId,
          paymentTotal: o.paymentTotal,
          expirationDate: o.expirationDate,
          solicitationCode: o.solicitationCode,
        },
        visualized: false,
      })
    );
    state.paymentSlipAnticipationNotifications =
      paymentSlipAnticipationNotifications;
  },

  [NOTIFICATIONS.MUTATE_EVENT]: (state, payload) => {
    const eventNotifications = payload.map((o) => {
      const title = enums.eventTitles[o.typeEvent]
        ? enums.eventTitles[o.typeEvent]
        : o.title;
      return {
        id: o._id,
        title: title,
        time: o.createdAt || o.date,
        link: o.notificationLink || { name: 'appointments' },
        type: types.EVENT,
        info: {
          typeEvent: o.typeEvent,
          typeEventName: EVENT_TYPES_BY_ID[o.typeEvent],
        },
        visualized: false,
      };
    });
    state.eventNotifications = eventNotifications;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications/mutations.js